<template>
<div>
		<div class="index_header_box clearfix_">
			<div @click="gotoIndex" class="fl index_header_logo"><img src="../../assets/image/logo.png" alt=""></div>
			<div class="fl index_header_title">数字底座{{title?'-'+title:''}}</div>
			<div @click="userShowFn" class="fr index_header_function"><img src="../../assets/image/index_function.png" alt="">
				<div v-show="userShow" class="user_list">
					<div @click='changePassword' class="user_item">修改密码</div>
					<div @click="signOut" class="user_item">退出登录</div>
				</div>
			</div>
      <div style="margin-right:50px;" class="fr index_header_title">{{userName}}</div>
		</div>
    <div :style="{height:height+'px'}" v-show="maskShow" class="mask_box">
      <div class="change_password_box">
        <div @click="maskHideFn" style="top:9px;" class="operating_detail_close"><img src="../../assets/image/close_blue.png" alt=""></div>
        <div class="change_password_title">修改密码</div>
        <div class="change_password_input">
          <div class="change_password_input_item clearfix_">
            <div class="fl change_password_input_item_name">请输入原密码</div>
            <div class="fl change_password_input_item_input"><el-input maxlength="20" class="change_password_input_input" placeholder="请输入原密码" show-password v-model="oldPsw"></el-input></div>
          </div>
          <div class="change_password_input_item clearfix_">
            <div class="fl change_password_input_item_name">请输入新密码</div>
            <div class="fl change_password_input_item_input"><el-input maxlength="20" class="change_password_input_input"  placeholder="请输入新密码" show-password v-model="newPsw1"></el-input></div>
          </div>
          <div class="change_password_input_item clearfix_">
            <div class="fl change_password_input_item_name">请确认新密码</div>
            <div class="fl change_password_input_item_input"><el-input maxlength="20" class="change_password_input_input"  placeholder="请确认新密码" show-password v-model="newPsw2"></el-input></div>
          </div>
        </div>
        <div class="change_password_btn clearfix_">
          <div @click="submit" class="fl">确定</div>
          <div @click="maskHideFn" class="fl">取消</div>
        </div>
      </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
import { ip,ip1 } from '@/assets/js/public.js'
export default {
  props: ['title'],
	data(){
		return{
      height:document.documentElement.clientHeight,
      oldPsw:'',
      newPsw1:'',
      newPsw2:'',
      maskShow:false,
      token:'',
      userName:''
		}
	},
  computed:{
		userShow(){
			return this.$store.state.userShow
		}
  },
	mounted:function(){
		this.token=localStorage.accessToken
    if(!this.token)return this.$router.push({name:'land',query:{}})
    this.userName=localStorage.userName
	},
	methods:{
    gotoIndex:function(){
      this.$router.push({path:'/index',query:{}})
    },
    signOut:function(){
      localStorage.setItem('accessToken','')
      localStorage.setItem('refreshToken','')
      localStorage.setItem('userId','')
      localStorage.setItem('userName','')
      this.$router.push({name: 'land',query: {}})
    },
    submit:function(){
      var t_=this
      if(!t_.oldPsw)return t_.$message({message:'请填写旧密码',center:true,type:'warning',customClass:'zZindex'})
      if(!t_.newPsw1)return t_.$message({message:'请填写新密码',center:true,type:'warning',customClass:'zZindex'})
      if(!/^[\w]{6,20}$/.test(t_.newPsw1))return t_.$message({message:'新密码为6-20位数字，字母，_组成',center:true,type:'warning',customClass:'zZindex'})
      if(!t_.newPsw2)return t_.$message({message:'请确认新密码',center:true,type:'warning',customClass:'zZindex'})
      if(!/^[\w]{6,20}$/.test(t_.newPsw2))return t_.$message({message:'新密码为6-20位数字，字母，_组成',center:true,type:'warning',customClass:'zZindex'})
      if(t_.newPsw1!=t_.newPsw2)return t_.$message({message:'新密码不一致',center:true,type:'warning',customClass:'zZindex'})
      var str=localStorage.Note
      var dataObj={
        "userId": parseFloat(localStorage.userId),
        "oldPass": t_.oldPsw,
        "newPass": t_.newPsw1,
        "newPass1": t_.newPsw2
      }
      axios.post(`${ip}api/Business/UpdatePassword`,dataObj,{headers:{authorization: `Bearer ${t_.token}`},}).then(res =>{
        if(res.data.code==20000){
          t_.maskShow=false
          t_.$message({
            message:res.data.message,
            center:true,
            type:'success',
            customClass:'zZindex'
          })
          this.oldPsw=''
          this.newPsw1=''
          this.newPsw2=''
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning',
            customClass:'zZindex'
          })
        }
      })
    },  
    maskHideFn:function(){
      this.maskShow=false
      this.oldPsw=''
      this.newPsw1=''
      this.newPsw2=''
    },
    changePassword:function(){
      var t_=this
      t_.maskShow=true
    },
    userShowFn:function(){
      if(this.userShow){
			  this.$store.commit('changePasswordShow',false)
      }else{
			  this.$store.commit('changePasswordShow',true)
      }
    },
	}
}
</script>

<style scoped>
	.index_header_box{
		width: 100%;
		height: 62px;
		background: #002FA7;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 99;
	}
	.index_header_logo{
		width: 150px;
		height: 55px;
		margin: 3px 25px 0 25px;
    cursor: pointer;
	}
	.index_header_logo img{
		/* width: 110px; */
		height: 55px;
	}
	.index_header_title{
		line-height: 62px;
		color: #fff;
		font-size: 18px;
		font-weight: 900;
    font-style:oblique;
    cursor: pointer;
	}
	.index_header_function{
		width: 30px;
		height: 30px;
		margin-right: 50px;
    margin-top: 17px;
		cursor: pointer;
	}
	.index_header_function img{
		width: 30px;
		height: 30px;
	}
  .header_user img{
    width: 30px;
    height: 30px;
  }
  .user_list{
    width: 100px;
    height: 100px;
    position: absolute;
    top: 62px;
    right: 15px;
		background: #344863;
    z-index: 9;
  }
  .user_item{
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 50px;
  }
  .mask_box{
    width: 100%;
    background: rgba(0,0,0,.8);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1999;
  }
  .change_password_box{
    width: 556px;
    height: 300px;
    position: fixed;
    left:0;
    right:0;
    top:0;
    bottom:0;
    margin:auto;
		background: #344863;
  }
  .change_password_input{
    width: 400px;
    margin: 0 auto;
  }
  .change_password_input_item{
    margin-bottom: 20px;
  }
  .change_password_input_item_name{
    color: #fff;
    line-height: 40px;
    font-size: 14px;
    margin-right: 30px;
  }
  .change_password_title{
    font-size: 18px;
    width: 100%;
    line-height: 42px;
    color: #fff;
    text-align: center;
    margin-bottom: 30px;
  }
  .change_password_btn{
    width: 196px;
    margin: 0 auto;
  }
  .change_password_btn div{
      font-size: 14px;
      padding: 8px 30px;
      color: #fff;
      cursor: pointer;
      background: #1f5be5;
      margin-right: 20px;
      color: #fff;
      border-radius: 3px;
  }
  .change_password_btn div:last-child{
      margin-right: 0;
      background: #5a5a5c;
  }
  .change_password_btn div:last-child{
    margin-right: 0;
  }
  .operating_detail_close{
    width: 25px;
    height: 25px;
    position: absolute;
    right: 20px;
    top: 12px;
    cursor: pointer;
  }
  .operating_detail_close img{
    width: 25px;
    height: 25px;
  }
</style>


// WEBPACK FOOTER //
// src/components/index/header.vue